'use client';

export const sendToProductFavorite = (pid: string, type: 'add' | 'delete') => {
  if (!window) return;

  const message = {
    cmd: 'productDidFavorite',
    parameters: {
      type,
      pid,
    },
  };

  // IOS
  globalThis.window.webkit?.messageHandlers?.Common?.postMessage?.(message);
  // AOS
  globalThis.window.Common?.productDidFavorite?.(pid, type);
};
